import React from 'react';
import { Nullable } from 'global';
import { grey } from '@mui/material/colors';
import { generateEquipmentName } from 'modules/equipment';
import { IconButton, Stack, Typography, Tooltip } from '@mui/material';
import { QuoteEquipmentWithCharge } from 'modules/quote/types';
import { Edit, Delete, SubdirectoryArrowRight } from '@mui/icons-material';
import { CHARGE_ROW_HEIGHT } from '../../../../../constants/form';

interface Props {
  onEditEquipment: (id: string) => void;
  onRemoveEquipment: (id: string) => void;
  equipment: Nullable<QuoteEquipmentWithCharge>;
}

export const EquipmentDescriptionCell = ({ equipment, onRemoveEquipment, onEditEquipment }: Props) => {
  if (!equipment) return null;

  return (
    <Stack sx={{ height: '100%', width: '100%', justifyContent: 'space-between' }}>
      <Stack width="100%" gap="0.5rem">
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Typography variant="subtitle2">{equipment.stockId}</Typography>

          <Stack direction="row" gap="0.5rem">
            <Tooltip title="Edit Equipment">
              <IconButton
                size="small"
                color="primary"
                className="icon-btn-bordered"
                onClick={() => {
                  onEditEquipment(equipment.equipmentId);
                }}
              >
                <Edit fontSize="small" />
              </IconButton>
            </Tooltip>

            <Tooltip title="Remove Equipment">
              <IconButton
                size="small"
                color="error"
                className="icon-btn-bordered"
                onClick={() => {
                  onRemoveEquipment(equipment.equipmentId);
                }}
              >
                <Delete fontSize="small" />
              </IconButton>
            </Tooltip>
          </Stack>
        </Stack>

        <Stack>
          <Typography fontWeight="bold">{generateEquipmentName(equipment)}</Typography>
          <Typography variant="caption">{equipment.additionalDescription ?? '-'}</Typography>
          <Typography variant="caption">Qty: {equipment.quantity ?? '-'}</Typography>
        </Stack>
      </Stack>

      <Stack gap="0.5rem">
        {equipment?.attachments?.map(attachment => (
          <Stack key={attachment.model} direction="row" alignItems="flex-start" minHeight={CHARGE_ROW_HEIGHT}>
            <SubdirectoryArrowRight color="disabled" />

            <Stack sx={{ marginTop: '0.3rem' }}>
              <Typography variant="caption" sx={{ backgroundColor: grey[200], borderRadius: '4px', padding: '0 8px' }}>
                Attachment
              </Typography>
              <Typography>{attachment.model}</Typography>
              <Typography variant="caption">Qty: {attachment.quantityPerAsset ?? '-'}</Typography>
            </Stack>
          </Stack>
        ))}
      </Stack>
    </Stack>
  );
};
